import { useCallback } from "react"

import { RootState, selectTokenBalance, useDappSelector } from "#/redux-state"
import { usePosthogButtonClickedEvent } from "#/shared/hooks"
import { AnalyticsId, VaultDepositFormValue } from "#/shared/types"
import { ComponentStepProps, useStepperModalContext } from "#/ui/Modal"

import VaultDepositForm from "./VaultDepositForm"

export default function VaultDepositStep({
  onClickContinue,
}: ComponentStepProps) {
  const { values: initialValues, setValues } =
    useStepperModalContext<VaultDepositFormValue>()

  const { emitButtonClickedEvent } = usePosthogButtonClickedEvent()

  const handelSubmitForm = useCallback(
    (values: VaultDepositFormValue) => {
      setValues(values)
      emitButtonClickedEvent(AnalyticsId.VAULT_REVIEW_DEPOSIT)
      onClickContinue()
    },
    [emitButtonClickedEvent, onClickContinue, setValues],
  )

  const tokenBalance = useDappSelector((state: RootState) =>
    selectTokenBalance(state, initialValues.token),
  )

  return (
    <VaultDepositForm
      initialValues={initialValues}
      onSubmitForm={handelSubmitForm}
      tokenBalance={tokenBalance}
    />
  )
}
